module.exports = __webpack_public_path__ + "static/media/SHDRLogo@2x.0430f2bf.png";